export default "__VITE_PUBLIC_ASSET__4aef445a__"